import React from "react";
import { OverlayBadge } from "./OverlayBadge";
import { useEditPanelState } from "../../graphql/hooks";

export const PathTemplateCheckOverlayBadge = () => {
    const { pathTemplateCheck } = useEditPanelState();

    if (!pathTemplateCheck) {
        return null;
    }

    return (
        <OverlayBadge
            badgeHeader="Path Template Error!"
            badgeVariant="danger"
            overlayText="Path template must not start with '/'"
            className="mt-2 p-1 me-2"
        />
    );
};
